/**
 * Class to build and render forms
 *
 * @author: Kete Martins
 * Date: 22/11/13
 * Time: 08:59
 */



Monet.Builder = Monet.Builder || {};
Monet.Builder.Form = Monet.Builder.Form || {};
Monet.Builder.Horizontal = Monet.Builder.Horizontal || {};

Monet.Builder.Form.Horizontal = (function (){

    /**
     * FormBuilder constructor
     * @param {object} pageLayout
     * @constructor
     */
   function FormBuilderHorizontal (pageLayout, entity) {

        Monet.Builder.Form.Base.apply (this, arguments);

        this.renderAndAppendTitle = function (parent, section) {

            var div = null;
            if (section && section.description && section.description.trim()) {
                div = document.createElement('div');
                var h1 = document.createElement('h1');
                div.className = 'MonetUIFormSectionTitle';
                h1.innerHTML = Monet.I18n.getResourcesByKey(section.description);

                div.appendChild(h1);
                parent.appendChild(div);
            }

            return parent;

        };

        this.renderRelatedList = function (relatedLists){

            var lists = relatedLists,
                container = null,
                divGridActions,
                divGridContainer;

            if(lists && lists.length > 0){

                container = document.createElement('div');
                container.className = 'MonetUIFormRelatedList';

                divGridActions = document.createElement('div');
                divGridActions.className = 'gridActions ui-widget-header';

                divGridContainer = document.createElement('div');
                divGridContainer.className = 'gridContainer';

                container.appendChild(divGridActions);
                container.appendChild(divGridContainer);

            }

            return container;

        };

        this.initializeGrid = function (customActions) {

            var grid = new Monet.Builder.Form.Grid (pageLayout, entity, customActions);
            grid.show();

        };

        this.render = function () {

            var baseForm = this.renderBaseForm ();
            var allContent = baseForm.allContent;

            this.fragment.appendChild(allContent);

            return this.fragment;
        };
   }

   return FormBuilderHorizontal;

}());